import {
  CreateMemberError,
  CreateMemberRequestParams,
  ListMembersRequestParams,
  SanitizedMember,
} from 'models/Member'

import { api } from '../api'
import toAPIv2QueryString from 'utils/functions/toAPIv2QueryString'

export const membersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createMember: builder.mutation<SanitizedMember | CreateMemberError, CreateMemberRequestParams>({
      query: (createMemberRequest) => ({
        url: '/members',
        method: 'POST',
        body: createMemberRequest,
      }),
    }),
    listMembers: builder.query<SanitizedMember[], ListMembersRequestParams>({
      query: (params: ListMembersRequestParams) => ({
        url: `/members?${toAPIv2QueryString(params)}`,
      }),
    }),
  }),
})

export const {
  useCreateMemberMutation,
  endpoints: { listMembers, createMember },
} = membersApi
